module.exports = __webpack_public_path__ + "static/media/manufacturing-process2.7c20ee6c.jpeg";